import {CustomError} from '../types/customErrors';

export class IOTSError extends CustomError {
  constructor(modelName: string, decodeError: string, rawModel?: string) {
    super(`[io-ts] Error parsing the model: ${modelName}: ${decodeError}`);

    this.modelName = modelName;
    this.decodeError = decodeError;
    this.rawModel = rawModel;
  }

  get groupingHash() {
    return `io-ts-${this.modelName}`;
  }

  readonly modelName: string;
  readonly decodeError: string;
  readonly rawModel?: string;
}

export class ApiBadResponseError extends CustomError {
  constructor(body?: any) {
    super('[io-ts] Bad API response');

    this.body = JSON.stringify(body, null, 2)?.slice(0, 1500);
  }

  readonly body: string;
}
